import axios from 'axios';
// ----------------------------------------------------------------------
const BASE_API = process.env.REACT_APP_API_URL;

const axiosInstance = axios.create({ baseURL: BASE_API });

axiosInstance.interceptors.response.use(
  (res) => res,
  (error) => Promise.reject(error)
);

export default axiosInstance;

// ----------------------------------------------------------------------

export const fetcher = async (args) => {
  const [url, config] = Array.isArray(args) ? args : [args];

  const res = await axiosInstance.get(url, { ...config });

  return res.data;
};

// ----------------------------------------------------------------------

export const endpoints = {
  chat: 'https://api-dev-minimal-v510.vercel.app/api/chat',
  api: {
    auth: {
      login: `${BASE_API}/api/auth/login`,
      getUser: `${BASE_API}/auth/user-exists`,
      registration: `${BASE_API}/auth/registration`,
    },
    financial: {
      getData: `${BASE_API}/api/financial/getdata`,
      getProfile: `${BASE_API}/api/financial/getprofile`,
    },
    analysis: {
      getFinancialAnalysis: `${BASE_API}/api/analysis/financial-analysis`,
      getComparativeAnalysis: `${BASE_API}/api/analysis/comparative-analysis`,
      getConsumptionAnalysis: `${BASE_API}/api/analysis/consumption-analysis`,
    },
  },
};
